import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Alerts, Btn } from "../../../AbstractElements";
import { LiveAlertText, LiveAlertTitle, ShowLiveAlert } from "../../../Constants/Constants";
import { LiveAlertSubTitle } from "../../../Data/UiKits/Alert";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const LiveAlert = () => {
  const [data, setData] = useState<number[]>([]);
  const removeValue = (item: number) => {
    setData(
      data.filter((value, index) => {
        return value !== item;
      })
    );
  };

  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={LiveAlertTitle} span={LiveAlertSubTitle} />
        <CardBody className="live-dark">
          {data.map((item: number, index: number) => (
            <Alerts color="light-dark" className="alert-dismissible" key={index}>
              <div>{LiveAlertText}</div>
              <Btn color="transperant" close onClick={() => removeValue(item)} />
            </Alerts>
          ))}
          <Btn color="dark" onClick={() => setData((prev) => [...prev, prev.length + 1])}>
            {ShowLiveAlert}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LiveAlert;
